module.exports = __webpack_public_path__ + "components/flag/static/square/sg-dc6e25b0c5609d4b65e4201a756c0309.svg";